var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-260 340.5 90 112.5",
    style: {
      enableBackground: "new -260 340.5 90 112.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#356BB1;stroke-width:2.8346;stroke-miterlimit:10;}\r\n\t.st1{fill:#356BB1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-181.1,451.6h-67.9c-5.5,0-10-4.5-10-10v-89.8c0-5.5,4.5-10,10-10h67.9c5.5,0,10,4.5,10,10v89.8 C-171.1,447.1-175.6,451.6-181.1,451.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-238.8,394.3c-0.1-0.1-0.2-0.2-0.2-0.3l-1.3-3.6c-0.1-0.3,0-0.7,0.3-0.8s0.7,0,0.8,0.3v0.1l1.2,3.4l8.6,6.8 l10.5,2.9l10.3-3.2l-2.3-3.3c-0.2-0.3-0.1-0.7,0.2-0.9c0.3-0.2,0.6-0.1,0.8,0.1l2.4,3.5l19.9-15.8l-27.8-12.1l-2.8,12.2l1.9,2.8 c0.2,0.3,0.1,0.6-0.2,0.8c-0.1,0.1-0.2,0.1-0.4,0.1s-0.4-0.1-0.5-0.3l-2.1-3c-0.1-0.1-0.1-0.3-0.1-0.5l2.8-12.2l-25.5,10.4l0,0 l1.3,3.5c0.1,0.3,0,0.7-0.4,0.8l0,0c-0.1,0-0.1,0-0.2,0c-0.3,0-0.5-0.2-0.6-0.4l-1.1-2.9l-10.9,20.2l10.4,15.4l13-17.6L-238.8,394.3 z M-214.9,389.4c0.3-0.2,0.6-0.1,0.8,0.2l1.9,2.7c0.2,0.3,0.1,0.7-0.2,0.9c-0.3,0.2-0.6,0.1-0.8-0.2l-1.8-2.7 C-215.3,390-215.2,389.6-214.9,389.4L-214.9,389.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-186.8,388.7c0,0.3-0.3,0.5-0.6,0.5h-0.1c-0.3-0.1-0.6-0.4-0.5-0.7l0.4-3.1l-19.3,15.3l-6.2,21.8l12.6,1.2 c0-0.1,0-0.2,0.1-0.3l9.8-17.2l0.8-5.5c0-0.3,0.4-0.6,0.7-0.5l0,0c0.3,0,0.6,0.4,0.5,0.7l0,0l-0.8,5.7c0,0.1,0,0.2-0.1,0.2 l-9.4,16.3l13.4-7.2l6.9-20.1l-7.7-11.1L-186.8,388.7z M-187.9,396.4c0,0.3-0.3,0.5-0.6,0.5h-0.1c-0.3-0.1-0.6-0.4-0.5-0.7l0.4-2.9 c0.1-0.3,0.4-0.6,0.7-0.5s0.6,0.4,0.5,0.7L-187.9,396.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-218.5,404.5c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0l-10.1-2.8l-1.1,14.1c0,0.3-0.3,0.6-0.6,0.6l0,0 c-0.3,0-0.6-0.3-0.6-0.7l0,0l0.9-12.7l-12.2,16.5l10.5,6.1l0.4-4.8c0-0.3,0.3-0.6,0.7-0.6s0.6,0.3,0.6,0.7l-0.4,4.9l16.5-3.3 c0-0.1,0-0.2,0-0.3l6-20.9L-218.5,404.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRock);
export default __webpack_public_path__ + "static/media/rock.0affd129e0a7dc7d0840b12020a3a18b.svg";
export { ForwardRef as ReactComponent };